import {
	createContext,
	Dispatch,
	SetStateAction,
	useEffect,
	useState,
} from 'react'

// components
import Footer from './components/footer/footer'
import Header from './components/header/header'
import Login from './components/login/login'
import StepCardNav from './components/step-card-nav/step-card-nav'
import BMRPage from './components/step-pages/bmr-page/bmr-page'
import DeltaVPage from './components/step-pages/deltav-page/deltav-page'
import NBAPage from './components/step-pages/nba-page/nba-page'
import UploadPage from './components/step-pages/upload-page/upload-page'
import Stepper from './components/stepper/stepper'

// styles
import styles from './App.module.scss'

// types
import { BiomechanicalResponse } from './types/biomechanical'
import { DeltaVResponse } from './types/deltav'

export type UploadedImageProps = {
	readonly fileName?: string
	readonly size?: number
	readonly url?: string
}

type AppContextProps = {
	readonly loggedIn?: Boolean
	readonly setLoggedIn: Dispatch<SetStateAction<boolean>>

	readonly currentStep: number
	setCurrentStep: Dispatch<SetStateAction<number>>

	readonly claimNumber?: string
	readonly setClaimNumber: Dispatch<SetStateAction<string | undefined>>

	readonly s3Uri?: string
	readonly setS3Uri: Dispatch<SetStateAction<string | undefined>>

	readonly uploadedImage?: UploadedImageProps
	readonly setUploadedImage: Dispatch<
		SetStateAction<UploadedImageProps | undefined>
	>

	readonly deltaV?: DeltaVResponse
	readonly setDeltaV: Dispatch<SetStateAction<DeltaVResponse | undefined>>

	readonly biomechanicalReport?: BiomechanicalResponse
	readonly setBiomechanicalReport: Dispatch<
		SetStateAction<BiomechanicalResponse | undefined>
	>
}

export const AppContext = createContext<AppContextProps | null>(null)

const App: React.FC = () => {
	const storage_loggedIn = 'TGL_LOGGD_IN'

	const [loggedIn, setLoggedIn] = useState(
		localStorage.getItem(storage_loggedIn) === 'true' ? true : false
	)
	const [currentStep, setCurrentStep] = useState<number>(1)
	const [claimNumber, setClaimNumber] = useState<string | undefined>()
	const [s3Uri, setS3Uri] = useState<string | undefined>()
	const [uploadedImage, setUploadedImage] = useState<
		UploadedImageProps | undefined
	>()
	const [deltaV, setDeltaV] = useState<DeltaVResponse | undefined>()
	const [biomechanicalReport, setBiomechanicalReport] = useState<
		BiomechanicalResponse | undefined
	>()

	useEffect(() => {
		localStorage.setItem(storage_loggedIn, String(loggedIn))

		if (!loggedIn) {
			setCurrentStep(1)
			setClaimNumber(undefined)
			setS3Uri(undefined)
			setUploadedImage(undefined)
			setDeltaV(undefined)
			setBiomechanicalReport(undefined)
		}
	}, [loggedIn])

	return (
		<AppContext.Provider
			value={{
				loggedIn,
				setLoggedIn,
				currentStep,
				setCurrentStep,
				claimNumber,
				setClaimNumber,
				s3Uri,
				setS3Uri,
				uploadedImage,
				setUploadedImage,
				deltaV,
				setDeltaV,
				biomechanicalReport,
				setBiomechanicalReport,
			}}
		>
			<div className={styles.app}>
				<Header />
				{!loggedIn ? (
					<Login />
				) : (
					<>
						<main className={styles.main}>
							<div className={styles.content}>
								<Stepper />

								{currentStep === 1 && <UploadPage />}
								{currentStep === 2 && <DeltaVPage />}
								{currentStep === 3 && <BMRPage />}
								{currentStep === 4 && <NBAPage />}

								<StepCardNav />
							</div>
						</main>

						<Footer />
					</>
				)}
			</div>
		</AppContext.Provider>
	)
}

export default App
